import React from 'react';

import useSupportedCurrencies from '../hooks/useSupportedCurrencies';

function Features() {
  const supportedCurrencies = useSupportedCurrencies()
  const supportedCurrenciesCount = supportedCurrencies.count || '...'

  return (
    <div>
      <div className="row mt-3 mb-5 landing-card-grid">
      <div className="col-md-6 col-lg my-2">
          <div className="landing-info-card h-100 text-center">
          <div className="landing-card-icon-wrap m-3">
            <img
              src="https://img.icons8.com/ios/64/000000/refresh.png"
              width="50px"
              alt="Live Gold & Silver Prices API"/>
          </div>
          <h4>100% <span className="hl-gold">Real-Time</span></h4>
          <span className="text-muted">Live Feed of <b>XAU</b>, <b>XAG</b>, <b>XPT</b>, <b>XPD</b> from FOREX, SAXO, OANDA and IDC Exchanges</span>
          </div>
        </div>
        <div className="col-md-6 col-lg my-2">
          <div className="landing-info-card h-100 text-center">
          <div className="landing-card-icon-wrap m-3">
            <img
              src="https://img.icons8.com/ios/64/000000/currency-exchange.png"
              width="50px"
              alt="Gold & Silver Prices API"/>
          </div>
          <h4>All <span className="hl-silver">Currencies</span></h4>
          <span className="text-muted">
            Live Metal Spot Prices & Exchange Rates in <b>USD</b>, <b>EUR</b>, <b>INR</b>, <b>AED</b>, <b>KWD</b>, <b>QAR</b>, <b>SAR</b> and{' '}
            <span className="pricing-currencies-tooltip-wrap">
              <button className="pricing-currencies-link" type="button">other {supportedCurrenciesCount} currencies</button>
              <span className="pricing-currencies-tooltip" role="tooltip">
                {supportedCurrencies.flaggedList || 'Loading...'}
              </span>
            </span>
          </span>
          </div>
        </div>
        <div className="col-md-6 col-lg my-2">
          <div className="landing-info-card h-100 text-center">
          <div className="landing-card-icon-wrap m-3">
            <img
              src="https://img.icons8.com/ios-glyphs/64/000000/diamond-2.png"
              width="50px"
              alt="Gold & Silver Prices API"/>
          </div>
          <h4><span className="hl-gold">Grams & Karats</span></h4>
          <span className="text-muted">Get prices in Troy Ounces, Grams and <b>Karats</b> (24, 22, 21, 20, 18, 16, 14, 10) Purity Grade</span>
          </div>
        </div>
        <div className="col-md-6 col-lg my-2">
            <div className="landing-info-card h-100 text-center">
            <div className="landing-card-icon-wrap m-3">
              <img
                src="https://img.icons8.com/ios/64/000000/activity-history.png"
                width="50px"
                alt="Historical Gold & Silver Prices API"/>
            </div>
            <h4> <span className="hl-silver">Historical</span> Prices</h4>
            <span className="text-muted">Historical LBMA AM Fix Gold & Silver Prices Since 1968</span>
            </div>
          </div>
        <div className="col-md-6 col-lg my-2">
          <div className="landing-info-card h-100 text-center">
            <div className="landing-card-icon-wrap m-3">
              <img
                src="https://img.icons8.com/ios/64/000000/bot.png"
                width="50px"
                alt="GoldAPI MCP Server for AI agents"/>
            </div>
            <h4>Use with <span className="hl-gold">AI Agents</span></h4>
            <span className="text-muted">Connect <b>ChatGPT, Claude, Codex</b> and other MCP-compatible AI clients to the GoldAPI MCP Server</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
